import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "./Loader";
import { clog } from "../lib/utils";

function LinkedInCallBackUrl() {
  const navigate = useNavigate();
  const [loading, setloading] = useState(false);
  const getLinkedInAccessToken = async (code) => {
    // clog(id);
    setloading(true);
    try {
      const response = await axios({
        url: `${
          process.env.REACT_APP_BASE_SIGNIN_URL
        }/linkedin/callback?code=${code}&user_id=${
          JSON.parse(localStorage.getItem("login_data"))?.resp_user?.id
        }`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
      });
      if (!response.data.error) {
        // window.open(response.data.url, "_self");
        localStorage.setItem("linkedin_access", JSON.stringify(response.data));
        let navigation = localStorage.getItem("linkedin_navigation")
          ? localStorage.getItem("linkedin_navigation")
          : "/integration-social";
        setTimeout(() => {
          navigate(navigation);
        }, 100);
      } else {
      }
    } catch (error) {
      clog(error);
      if (error.response && error?.response?.status == 401) {
        localStorage.removeItem("login_token");
        localStorage.removeItem("login_data");
        navigate("/");
      }
    } finally {
      setloading(false);
    }
  };
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    let code = searchParams.get("code");

    if (code) {
      getLinkedInAccessToken(code);
    }
  }, []);

  return (
    <div className="flex justify-center items-center h-screen">
      {loading && <Loader />}
    </div>
  );
}

export default LinkedInCallBackUrl;
